export default {
  '场所':'场所',
  '批量解绑':'批量解绑',
  '已选中{selectedCount}人':'已选中{selectedCount}人',
  '取消全部选中':'取消全部选中',
  '解绑':'解绑',
  '设备名、序列号模糊搜索':'设备名、序列号模糊搜索',
  '机构名称':'机构名称',
  '机构代码':'机构代码',
  '设备名称':'设备名称',
  '序列号':'序列号',
  'MAC地址':'MAC地址',
  '场所名称':'场所名称',
  '激活时间':'激活时间',
  '设备状态':'设备状态',
  '是否确认批量解绑{selectedCount}个设备？':'是否确认批量解绑{selectedCount}个设备？',
  '是否确认解绑设备{deviceName}？':'是否确认解绑设备{deviceName}？',
  '解绑成功！':'解绑成功！',
  '软件版本':'软件版本',
  '子设备':'子设备',
  '当前版本':'当前版本',
  '子设备列表':'子设备列表',
  '子设备名称':'子设备名称',
  '序列号':'序列号',
  'MAC 地址':'MAC 地址',
  '激活时间':'激活时间',
  '应用及版本':'应用及版本',
  '设备详情':'设备详情',
  '设备信息':'设备信息',
  '应用信息':'应用信息',
  '专注模式':'专注模式',
  '设置专注模式':'设置专注模式',
  '专注时间':'专注时间',
  '确定关闭本设备的专注模式吗？':'确定关闭本设备的专注模式吗？',
  '仅支持部分设备':'仅支持部分设备：固定测试站 - 专项 (跑步)、固定测试站 - 通用 (室内 AI)、固定测试站 - 通用 (室内传感)、智慧屏 设备',
}